import React, { useState, useEffect } from 'react';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaBars } from 'react-icons/fa';
import { useAuthContext } from '../../../context/AuthContext';
import { STORAGE_KEYS } from '../../../api/config';
import spApi from '../../../api/serviceProviders/spApi';
import authApi from '../../../api/auth/authApi';

import '../../admin/layout/style/TopNav.css';

const ServiceTopNav = ({ toggleSidebar, sidebarCollapsed }) => {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [profile, setProfile] = useState(null);

  // Fetch provider profile for the top nav name
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await spApi.getProfile();
        if (response.success || response.status === 800) {
          setProfile(response.data?.provider || response.data || {});
        }
      } catch (err) {
        console.error('Error fetching provider profile:', err);
      }
    };
    fetchProfile();
  }, []);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear localStorage
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
      localStorage.removeItem(STORAGE_KEYS.USER_ID);
      localStorage.removeItem(STORAGE_KEYS.UID);
      localStorage.removeItem(STORAGE_KEYS.EVENT_ID);
      localStorage.removeItem('selectedEventId');

      setShowLogoutModal(false);
      navigate('/login');
    }
  };

  return (
    <nav
      className="top-nav"
      style={{
        left: windowWidth <= 768
          ? 'max(0px, calc((100vw - 1600px) / 2))'
          : `max(${sidebarCollapsed ? '70px' : '140px'}, calc((100vw - 1600px) / 2 + ${sidebarCollapsed ? '70px' : '140px'}))`,
        right: 'max(0px, calc((100vw - 1600px) / 2))'
      }}
    >
      <div className="left-section">
        <button onClick={toggleSidebar} className="toggle-btn">
          <FaBars />
        </button>
      </div>

      <div className="d-flex align-items-center">
        <Dropdown align="end" className="admin-dropdown">
          <Dropdown.Toggle
            variant="transparent"
            id="dropdown-basic"
            className="d-flex align-items-center text-truncate admin-toggle"
            style={{ color: '#4a85ff', maxWidth: '200px', border: 'none', background: 'transparent' }}
          >
            <div className="flex-shrink-0 me-2">
              <i className="bi bi-person-circle" style={{ fontSize: '24px', color: '#4169e1' }}></i>
            </div>
            <span className="text-truncate fw-bold">
              {profile?.name || user?.full_name || user?.name || 'Mtoa Huduma'}
            </span>
          </Dropdown.Toggle>

          <Dropdown.Menu className="admin-menu">
            <Dropdown.Item onClick={() => navigate('/service-provider/profile')}>
              <FaUser className="menu-icon" /> Profile
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item
              onClick={() => setShowLogoutModal(true)}
              style={{ padding: '8px 15px', color: '#dc3545' }}
              className="logout-item"
            >
              <FaSignOutAlt className="menu-icon text-danger" />
              Log out
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Logout Confirmation Modal */}
      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        centered
        className="logout-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="h5">Logout Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center pt-2 pb-4">
          <div className="logout-icon-wrapper mb-3">
            <FaSignOutAlt className="text-warning display-4" />
          </div>
          <p className="mb-0 text-muted">Are you sure you want to log out of the system?</p>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 justify-content-center">
          <Button variant="light" className="px-4" onClick={() => setShowLogoutModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" className="px-4" onClick={handleLogout}>
            Yes, Log out
          </Button>
        </Modal.Footer>
      </Modal>
    </nav>
  );
};

export default ServiceTopNav;
